<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.plus-circle-solid"></svg-vue>
          <h1 class="content-title">
            {{ $t('Create repair order') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <router-link class="btn btn-app" to="/">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <form @submit.prevent="saveRepair">
        <div class="grid grid-cols-10 gap-2">
          <loading :status="loading"></loading>
          <div class="col-span-10 md:col-span-7 content-card-body">
            <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
              <div class="md:col-span-1">
                <h3 class="form-description-head">
                  {{ $t('Repair information') }}
                </h3>
                <p class="form-description-text">{{ $t('Fill up required information') }}.</p>
              </div>
              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="grid grid-cols-3 gap-6">
                  <div class="col-span-3">
                    <div class="flex justify-between">
                      <label class="form-label" for="name">{{ $t('Name') }}</label>
                      <button @click.prevent="moreOptions = !moreOptions">{{ $t('options') }}</button>
                    </div>
                    <div class="pt-1 relative rounded-md shadow-sm">
                      <input :placeholder="$t('Name')" class="form-input" id="name" required v-model="repair.name" />
                    </div>
                  </div>
                  <template v-if="moreOptions">
                    <div class="col-span-3">
                      <label class="form-label" for="email">{{ $t('Email') }}</label>
                      <div class="pt-1 relative rounded-md shadow-sm">
                        <input :placeholder="$t('Email')" class="form-input" id="email" type="email" v-model="repair.email" />
                      </div>
                    </div>
                    <div class="col-span-3">
                      <label class="form-label" for="phone">{{ $t('Phone') }}</label>
                      <div class="pt-1 relative rounded-md shadow-sm">
                        <input :placeholder="$t('Phone')" class="form-input" id="phone" v-model="repair.phone" />
                      </div>
                    </div>
                    <div class="col-span-3">
                      <label class="form-label" for="address">{{ $t('Address') }}</label>
                      <div class="pt-1 relative rounded-md shadow-sm">
                        <input :placeholder="$t('Address')" class="form-input" id="address" type="address" v-model="repair.address" />
                      </div>
                    </div>
                  </template>
                </div>
              </div>
              <div class="md:col-span-3">
                <div class="py-3">
                  <div class="border-t border-gray-200"></div>
                </div>
              </div>
              <div class="md:col-span-1">
                <h3 class="form-description-head">
                  {{ $t('Issue description') }}
                </h3>
                <p class="form-description-text">{{ $t('User access and permission settings') }}.</p>
              </div>
              <div class="mt-5 md:mt-0 md:col-span-2">
                <div class="grid grid-cols-3 gap-6">
                  <div class="col-span-3">
                    <label class="form-label" for="issue">{{ $t('Issue') }}</label>
                    <div class="pt-1 relative rounded-md">
                      <textarea class="form-input" id="issue" v-model="repair.issue" rows="5"></textarea>
                    </div>
                  </div>
                  <div class="col-span-3">
                    <label class="form-label" for="device_name">{{ $t('Device name') }}</label>
                    <div class="pt-1 relative rounded-md shadow-sm">
                      <input :placeholder="$t('Device name')" class="form-input" id="device_name" v-model="repair.device_name" />
                    </div>
                  </div>
                  <div class="col-span-3">
                    <label class="form-label" for="imei">{{ $t('IMEI') }}</label>
                    <div class="pt-1 relative rounded-md shadow-sm">
                      <input :placeholder="$t('IMEI')" class="form-input" id="imei" v-model="repair.imei" />
                    </div>
                  </div>
                  <div class="col-span-3">
                    <label class="form-label" for="serial_number">{{ $t('Serial number') }}</label>
                    <div class="pt-1 relative rounded-md shadow-sm">
                      <input :placeholder="$t('Serial number')" class="form-input" id="serial_number" v-model="repair.serial_number" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="col-span-10 md:col-span-3 content-card-body px-4 py-5 sm:p-6">
            <div class="col-span-3">
              <label class="form-label" for="message">{{ $t('Message for customer') }}</label>
              <div class="pt-1 relative rounded-md">
                <textarea class="form-input" id="message" v-model="repair.message" rows="5"></textarea>
              </div>
            </div>
            <div class="col-span-3 mt-2">
              <label class="form-label" for="charges">{{ $t('Charges') }}</label>
              <div class="pt-1 relative rounded-md shadow-sm">
                <input :placeholder="$t('Charges')" class="form-input" type="number" step="0.01" id="charges" v-model="repair.charges" />
              </div>
            </div>
            <div class="col-span-3 mt-2">
              <label class="form-label" for="Cost">{{ $t('Cost') }}</label>
              <div class="pt-1 relative rounded-md shadow-sm">
                <input :placeholder="$t('Cost')" class="form-input" type="number" step="0.01" id="Cost" v-model="repair.cost" />
              </div>
            </div>

            <div class="col-span-3 mt-2">
              <label class="form-label" for="pre_paid">{{ $t('Prepaid amount') }}</label>
              <div class="pt-1 relative rounded-md shadow-sm">
                <input :placeholder="$t('Prepaid amount')" class="form-input" type="number" step="0.01" id="pre_paid" v-model="repair.pre_paid" />
              </div>
            </div>
            <div class="col-span-3 mt-2">
              <div class="flex justify-between">
                <strong>{{ $t('Charges') }} :</strong> {{ repair.charges | currency }}<br />
              </div>
              <div class="flex justify-between">
                <strong>{{ $t('Cost') }} :</strong> {{ repair.cost | currency }}<br />
              </div>
              <div class="flex justify-between">
                <strong>{{ $t('Expected profit') }} :</strong> {{ profitAmount | currency }}<br />
              </div>
              <hr class="my-2" />
              <div class="flex justify-between">
                <strong>{{ $t('Tax') }} :</strong> {{ taxAmount | currency }}<br />
              </div>
              <div class="flex justify-between">
                <strong>{{ $t('After tax') }} :</strong> {{ afterTax | currency }}<br />
              </div>
              <div class="flex justify-between">
                <strong>{{ $t('Paid amount') }} :</strong> {{ repair.pre_paid | currency }}<br />
              </div>
              <div class="flex justify-between">
                <strong>{{ $t('Due amount') }} :</strong> {{ due | currency }}<br />
              </div>
            </div>
          </div>
        </div>
        <div class="card-footer mt-2 overflow-hidden shadow rounded-md">
          <span class="inline-flex">
            <router-link class="btn btn-app mr-4" to="/">{{ $t('Cancel') }}</router-link>
            <button class="btn btn-app" :disabled="loading" type="submit">
              {{ $t('Save') }}
            </button>
          </span>
        </div>
      </form>
    </div>
  </main>
</template>
<script>
export default {
  name: 'new',
  metaInfo() {
    return {
      title: this.$i18n.t('Create repair order'),
    };
  },
  data() {
    return {
      loading: false,
      moreOptions: false,
      repair: {
        status: false,
        name: null,
        email: null,
        phone: null,
        address: null,
        device_name: null,
        serial_number: null,
        imei: null,
        issue: null,
        cost: 0,
        profit: 0,
        tax: {
          rate: 0,
          is_tax_included: false,
          is_tax_fix: false,
          tax_id: null,
        },
        tax_amount: 0,
        charges: 0,
        due: null,
        pre_paid: 0,
      },
    };
  },
  mounted() {
    this.repair.tax = this.$store.getters['app/getTaxSetup'];
  },

  computed: {
    profitAmount() {
      return Number(this.repair.charges) - Number(this.repair.cost);
    },
    taxAmount() {
      const amount = this.repair.charges;
      if (this.repair.tax.is_vat) {
        let rating = '1.' + this.repair.tax.tax_rate ?? this.repair.tax.rate;
        if (this.repair.tax.is_tax_included) {
          return Number(amount - Number(amount / rating));
        } else {
          return Number(Number(amount * rating) - amount);
        }
      } else {
        const rate = Number(this.repair.tax.tax_rate ?? this.repair.tax.rate);
        if (this.repair.tax.is_tax_fix) {
          return rate;
        }
        return amount * (rate / 100);
      }
    },
    afterTax() {
      if (this.repair.tax.is_tax_included) {
        return Number(this.repair.charges);
      }
      return Number(this.repair.charges) + Number(this.taxAmount);
    },
    due() {
      return Number(this.afterTax - this.repair.pre_paid);
    },
  },
  methods: {
    saveRepair() {
      this.repair.total_amount = this.afterTax;
      this.repair.due = this.due;
      this.repair.tax_amount = this.taxAmount;
      this.repair.profit = this.profitAmount;
      this.loading = true;
      axios
        .post(route('repairs.store'), this.repair)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push(`/print/repair/${response.data.repair}`);
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
